/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * One row of LinkedIn's ``Connections.csv``, parsed in the browser.
 *
 * Unknown fields are rejected so an email column can never be sent.
 */
export interface ConnectionRow {
  first_name?: string | null;
  last_name?: string | null;
  url?: string | null;
  company?: string | null;
  position?: string | null;
  connected_on?: string | null;
}
